'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _helpersApiClient = require('../../helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _constants = require('../../constants');

var _constants2 = _interopRequireDefault(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _componentsFormUserLookup = require('../../components/Form/UserLookup');

var _componentsFormUserLookup2 = _interopRequireDefault(_componentsFormUserLookup);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _MiniList = require('./MiniList');

var _MiniList2 = _interopRequireDefault(_MiniList);

var _components = {
	_$ItemSubform: {
		displayName: 'ItemSubform'
	},
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ItemSubform = (function (_React$Component) {
	_inherits(ItemSubform, _React$Component);

	function ItemSubform(props) {
		_classCallCheck(this, _ItemSubform);

		_React$Component.call(this, props);
		this.state = {
			overRemove: false
		};
	}

	ItemSubform.prototype.handleMouseOver = function handleMouseOver() {
		this.setState({ overRemove: true });
	};

	ItemSubform.prototype.handleMouseOut = function handleMouseOut() {
		this.setState({ overRemove: false });
	};

	ItemSubform.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			'tr',
			{ className: this.state.overRemove ? 'subformOverRemove' : null },
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement(_reactisForms.FormField, { name: 'title' })
			),
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement(_reactisForms.FormField, { name: 'price' })
			),
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement('i', { title: 'Odstranit',
					onClick: this.props.onRemove,
					onMouseOver: function () {
						return _this.handleMouseOver();
					},
					onMouseOut: function () {
						return _this.handleMouseOut();
					},
					className: 'icon-cross removesubform' })
			)
		);
	};

	var _ItemSubform = ItemSubform;
	ItemSubform = _wrapComponent('_$ItemSubform')(ItemSubform) || ItemSubform;
	return ItemSubform;
})(_react2['default'].Component);

;

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'invoice.fetch',
			save: 'invoice.save',
			remove: 'invoice.delete'
		};

		this.changeEvent = 'invoice.change';

		this.messages = {
			remove: 'Opravdu si přejete fakturu odstranit?',
			notfound: 'Faktura nenalezena!'
		};

		this.schema = {
			number: {
				'class': _reactisInputs.TextInput,
				label: 'Číslo',
				rules: {
					presence: { message: 'Číslo faktury je povinná položka faktury!' }
				}
			},
			client: {
				'class': _componentsFormClientLookup2['default'],
				label: 'Klient'
			},
			date1: {
				'class': _reactisInputs.DatePicker,
				label: 'Datum vystavení',
				value: new _moment2['default']().format('YYYY-MM-DD')
			},
			date2: {
				'class': _reactisInputs.DatePicker,
				label: 'Datum splatnosti'
			},
			items: {
				'class': _reactisForms.Multiform,
				label: 'Položky',
				addLabel: 'přidat položku',
				value: [{ id: -1, title: '' }],
				subform: ItemSubform,
				showHeader: false,
				schema: {
					title: {
						'class': _reactisInputs.TextInput,
						label: 'Text',
						style: { width: 400 } /*,
                            rules: {
                            presence: {message: 'Text je povinná položka!'},
                            length: {
                            minimum: 5,
                            message: 'Název musí být delší než 5jeden znak.'
                            }
                            }*/
					},
					price: {
						'class': _reactisInputs.Number,
						label: 'Cena',
						style: { width: 80 },
						addonAfter: 'Kč'
					}
				}
			},
			order: {
				'class': _reactisInputs.TextInput,
				label: 'Objednávka'

			},
			vs: {
				'class': _reactisInputs.TextInput,
				label: 'Variabilní symbol'
			},
			text: {
				'class': _reactisInputs.TextInput,
				label: 'Popis'
			},
			qrmsg: {
				'class': _reactisInputs.TextInput,
				label: 'QR zpráva'
			},
			status: {
				'class': _reactisInputs.Select,
				options: _dbinfo2['default'].InvoiceStatus.asArray(),
				value: _constants2['default'].INVOICE_STATUS.NEW,
				nullable: false,
				label: 'Stav'
			},
			notice: {
				'class': _reactisInputs.TextArea,
				label: 'Poznámka',
				style: { height: '40px' }
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.form.on('change', function (key, value) {
			if (key == 'number') {
				_this2.title = '#' + value;
			}
			_this2.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: '#' + data.number });
	};

	Form.prototype.handleDownload = function handleDownload(toEmail) {
		var api = new _helpersApiClient2['default']();
		api.call('invoice.download', { id: this.props.id, toEmail: toEmail }).then(function (data) {
			if (data) {
				window.location = data.url;
			}
		});
	};

	Form.prototype.render = function render() {
		var _this3 = this;

		var loading = !!(this.props.form && this.props.form.get('loading'));
		var client = this.props.form && this.props.form.getIn(['values', 'client']) && this.props.form.getIn(['values', 'client']).toJS();

		var canEdit = true || this.user.isAllowed('user', 'update');
		var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
			disabled: !canEdit,
			loading: !!(this.props.form && this.props.form.get('saving')),
			onClick: function () {
				return _this3.save();
			}
		});

		var printButton = _react2['default'].createElement(
			_reactBootstrap.DropdownButton,
			{ id: 'print', style: { marginLeft: 5 }, bsStyle: 'success', title: _react2['default'].createElement(
					'span',
					null,
					_react2['default'].createElement('i', { className: 'fa fa-print' }),
					' Tisk'
				) },
			_react2['default'].createElement(
				_reactBootstrap.MenuItem,
				{ onSelect: this.handleDownload.bind(this, true), eventKey: '1' },
				'Do e-mailu'
			),
			_react2['default'].createElement(
				_reactBootstrap.MenuItem,
				{ onSelect: this.handleDownload.bind(this, false), eventKey: '2' },
				'Do obálky'
			)
		);

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			saveButton,
			this.props.id > 0 && _react2['default'].createElement(
				_componentsActionButton2['default'],
				{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
						return _this3.remove();
					} },
				'Odstranit'
			),
			this.props.id > 0 && printButton
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Faktura', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-8' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_Object$keys(this.schema).filter(function (key) {
									return ['vs', 'order', 'status'].indexOf(key) == -1;
								}).map(function (key) {
									return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this3.schema[key].visible, name: key, labelWidth: '135' });
								})
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-4' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'vs', labelWidth: '135' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'order', labelWidth: '135' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'status', labelWidth: '135' })
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-8' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons', labelWidth: '135' },
									saveButton
								)
							)
						)
					),
					client && client.id && _react2['default'].createElement(
						'div',
						{ className: 'col-md-8' },
						_react2['default'].createElement(
							'h5',
							null,
							'Předchozí faktury'
						),
						_react2['default'].createElement(_MiniList2['default'], { client: client && client.id,
							actions: this.props.tabActions,
							id: this.props.tabid
						})
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Invoice/Form.js
 ** module id = 985
 ** module chunks = 2
 **/